import { Grid, Link, Typography } from '@material-ui/core'
import ConfigurationItem, { ConfigurationItemOption } from 'components/ConfigurationItem/ConfigurationItem'
import { ConfigurationLink } from 'graphql/types'
import { useTranslation } from 'react-i18next'
import { OptionType } from 'store/GeneralState/GeneralState.reducer'
import TestIDs from 'utils/TestIDs'

export interface ConfigurationRadioProps {
    title: string
    helpText?: string
    selected: string | string[]
    link?: ConfigurationLink
    marginBottom?: number | string
    marginTop?: number | string
    titleHidden?: boolean
    options: ConfigurationItemOption[]
    onSelect: (value: string) => void
}

const ConfigurationRadio = (props: ConfigurationRadioProps): JSX.Element => {
    const { t } = useTranslation()
    const { title, helpText, selected, link, marginBottom, options, marginTop, onSelect, titleHidden } = props
    const selectedVal: string[] = []
    // this happens from the configuaration where it can be saved as an string or array of strings
    if ((selected as any) instanceof Array) {
        selectedVal.push(...selected)
    } else if (typeof selected === 'string') {
        selectedVal.push(selected)
    }

    return (
        <Grid
            container
            spacing={1}
            style={{
                marginBottom: marginBottom !== undefined ? marginBottom : '50px',
                marginTop: marginTop !== undefined ? marginTop : '0px',
            }}
        >
            <Grid item xs={12}>
                {(titleHidden === undefined || titleHidden === false) && (
                    <Typography {...TestIDs.GET_CONFIGURATION('RADIO', 'TITLE')} variant={'h4'}>
                        {t(title)}
                    </Typography>
                )}
                {link && (
                    <Link
                        href={link.url}
                        target={'_blank'}
                        {...TestIDs.GET_CONFIGURATION('RADIO', 'LINK')}
                        className={'ConfigurationLink'}
                    >
                        <Typography variant={'h5'}>{t(link.text)}</Typography>
                    </Link>
                )}
            </Grid>
            {options.map(
                (option: ConfigurationItemOption): JSX.Element => (
                    <ConfigurationItem
                        key={option.value + option.label}
                        selected={selectedVal.includes(option.value)}
                        option={option}
                        type={OptionType.RADIO}
                        onSelect={onSelect}
                    />
                ),
            )}
            {selected === 'viaMail' && t('bankDetailsStrings.viaMailHint') !== 'bankDetailsStrings.viaMailHint' && (
                <Grid item xs={12}>
                    <Typography>{t('bankDetailsStrings.viaMailHint')}</Typography>
                </Grid>
            )}
            {helpText && (
                <Grid item xs={12}>
                    <Typography
                        {...TestIDs.GET_CONFIGURATION('RADIO', 'HELP_TEXT')}
                        variant={'subtitle1'}
                        className={'ConfigurationHelpText'}
                        dangerouslySetInnerHTML={{
                            __html: t(helpText),
                        }}
                    />
                </Grid>
            )}
        </Grid>
    )
}

export default ConfigurationRadio
